<ng-template #listTemplate let-visibleUsers>
  <div
    *ngFor="let user of visibleUsers; trackBy: trackById"
    [class.disabled]="disabledIds[user.id]"
    [class.selected]="selectedIds.has(user.id)"
    class="result"
  >
    <rt-group (click)="toggleAssignment(user)" variant="horizontal">
      <span
        [rtTooltipHasTextAlignCenter]="true"
        [rtTooltipMaxWidth]="245"
        [rtTooltip]="disabledIds[user.id] && lockedAssignmentsTooltip"
      >
        <rt-checkbox
          (click)="toggleAssignment(user)"
          [checked]="selectedIds.has(user.id)"
          [disabled]="disabledIds[user.id]"
          [value]="$any(user.id)"
        >
        </rt-checkbox>
      </span>
      <rt-avatar
        [imageSrc]="user.photoThumbUrl"
        [initials]="user.initials"
        [shape]="'oval'"
        [size]="'base'"
        [type]="user.hasAvatar ? 'image' : 'initials'"
        context="admin"
      ></rt-avatar>
      <div layout-vertical margin-left-small>
        <rt-heading>
          <rt-truncate> {{ user.firstName }} {{ user.lastName }} </rt-truncate>
        </rt-heading>
        <span>{{ user.email }}</span>
      </div>
    </rt-group>
    <rt-divider></rt-divider>
  </div>
</ng-template>

<ng-template #disabledListTemplate let-visibleUsers>
  <div *ngFor="let user of visibleUsers; trackBy: trackById" class="result result__disabled">
    <rt-group
      [rtTooltipMaxWidth]="260"
      [rtTooltip]="'app.candidate.admin_select.no_access.tooltip' | translate"
      rtTooltipPosition="left"
      variant="horizontal"
    >
      <rt-checkbox [disabled]="true" />
      <rt-avatar
        [imageSrc]="user.photoThumbUrl"
        [initials]="user.initials"
        [shape]="'oval'"
        [size]="'base'"
        [type]="user.hasAvatar ? 'image' : 'initials'"
        context="admin"
      ></rt-avatar>
      <div class="admin-info" layout-vertical margin-left-small>
        <span class="heading">{{ user.firstName }} {{ user.lastName }}</span>
        <span>{{ user.email }}</span>
      </div>
    </rt-group>
    <rt-divider></rt-divider>
  </div>
</ng-template>

<rt-dialog-header
  [heading]="heading"
  [subheading]="showCountBeforeSubheading ? selectedIds.size + ' ' + subheading : subheading"
  [stepText]="inviteModeEnabled ? ('app.candidate.admin_select.step_1_of_2' | translate) : ''"
>
</rt-dialog-header>

<rt-dialog-body>
  <rt-spinner *ngIf="loadingAdmins"></rt-spinner>

  <div column-layout layout-full-width>
    <rt-box *ngIf="!loadingAdmins" variant="vertical background no-padding">
      <div class="search">
        <rt-form-field>
          <rt-input
            (reset)="cancelSearch()"
            [autoFocus]="true"
            [formControl]="searchControl"
            [hasClearButton]="true"
            [placeholder]="'app.common.placeholders.search.team_members.other' | translate"
            variant="rounded"
          >
            <rt-icon name="search" prefix></rt-icon>
          </rt-input>
        </rt-form-field>

        <rt-group *ngIf="!inviteModeEnabled" class="select-options" variant="horizontal">
          <rt-button (click)="selectAll()" variant="plain">
            {{ 'app.common.all' | translate }}
          </rt-button>
          <rt-button (click)="selectNone()" variant="plain">
            {{ 'app.common.none' | translate }}
          </rt-button>
        </rt-group>
      </div>

      <rt-divider variant="line"></rt-divider>

      <div
        *ngIf="filteredUsersExceedVirtualScrollThreshold"
        [bufferAmount]="10"
        [executeRefreshOutsideAngularZone]="true"
        [items]="virtualScrollItems"
        [scrollAnimationTime]="0"
        [scrollThrottlingTime]="0"
        [enableUnequalChildrenSizes]="true"
        (vsUpdate)="onVirtualScrollUpdate($event)"
        class="results results--virtual"
        virtualScroller
      >
        <ng-template
          [ngTemplateOutletContext]="{ $implicit: virtualScrollUsers }"
          [ngTemplateOutlet]="listTemplate"
        ></ng-template>
        <ng-container *ngIf="isATCEnabled">
          <div *ngIf="!!filteredDisallowedUsers.length" class="header" padding-lr padding-tb-small>
            <rt-heading variant="subheading">
              {{ 'app.candidate.admin_select.no_access.header' | translate | uppercase }}
            </rt-heading>
          </div>
          <ng-template
            [ngTemplateOutlet]="disabledListTemplate"
            [ngTemplateOutletContext]="{ $implicit: virtualScrollDisabledUsers }"
          ></ng-template>
        </ng-container>
      </div>
      <div *ngIf="!filteredUsersExceedVirtualScrollThreshold" class="results">
        <ng-template
          [ngTemplateOutletContext]="{ $implicit: filteredUsers }"
          [ngTemplateOutlet]="listTemplate"
        ></ng-template>
        <ng-container *ngIf="isATCEnabled">
          <div *ngIf="!!filteredDisallowedUsers.length" class="header" padding-lr padding-tb-small>
            <rt-heading variant="subheading">
              {{ 'app.candidate.admin_select.no_access.header' | translate | uppercase }}
            </rt-heading>
          </div>
          <ng-template
            [ngTemplateOutlet]="disabledListTemplate"
            [ngTemplateOutletContext]="{ $implicit: filteredDisallowedUsers }"
          ></ng-template>
        </ng-container>
      </div>

      <rt-empty-state
        *ngIf="!filteredUsers.length && !filteredDisallowedUsers.length"
        [icon]="'search'"
        [title]="'app.common.no_results_found' | translate"
        variant="small"
      >
        <rt-button (click)="cancelSearch()" variant="tertiary">
          {{ 'app.assignments.editor.clear_search' | translate }}
        </rt-button>
      </rt-empty-state>
    </rt-box>
  </div>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button (click)="cancel()" *ngIf="!loading" variant="plain">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button (click)="submit()" [disabled]="!isValid()" [loading]="loading" variant="primary">
    {{ (inviteModeEnabled ? 'app.common.continue' : 'app.common.save') | translate }}
  </rt-button>
</rt-dialog-footer>
